export default __webpack_public_path__ + "908a1dfb68a47803aab178a8409c9eda.png";